namespace TabAurous.Purchase {
    export namespace ApprovalInItemsService {
        export const baseUrl = 'Purchase/ApprovalInItems';

        export declare function Create(request: Serenity.SaveRequest<ApprovalInItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ApprovalInItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ApprovalInItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalInItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalInItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetItemDetails(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalInItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/ApprovalInItems/Create",
            Update = "Purchase/ApprovalInItems/Update",
            Delete = "Purchase/ApprovalInItems/Delete",
            Retrieve = "Purchase/ApprovalInItems/Retrieve",
            List = "Purchase/ApprovalInItems/List",
            CustomList = "Purchase/ApprovalInItems/CustomList",
            GetItemDetails = "Purchase/ApprovalInItems/GetItemDetails"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'GetItemDetails'
        ].forEach(x => {
            (<any>ApprovalInItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
